/**
 * Buttons
 */
(function() {
    'use strict';

    function initManifestoToggle() {
        const btnManifestoToggle = document.querySelector('.js-btnManifestoToggle');
        const btnOpenClass = 'layoutMain__manifestoCont__btnManifestoToggle--open';

        btnManifestoToggle.addEventListener('click', function(event) {
            const clickedTarget = event.currentTarget;

            clickedTarget.classList.toggle(btnOpenClass);
        });
    }

    function initBtnMobTop() {
        const btnTopMob = document.querySelector('.js-btnTopMob');
        const mainContentContainer = document.querySelector('.js-mainContent');
        const scrollContainer = document.querySelector('.borderOuter') || mainContentContainer;

        if (!btnTopMob || !scrollContainer) {
            return;
        }

        btnTopMob.addEventListener('click', function() {
            smoothScroll(0, 800, scrollContainer);
        });
    }

    initManifestoToggle();
    initBtnMobTop();
})();


/**
 * Add resize_x and resize_y events
 */
(function () {
    'use strict';

    let screenX = window.innerWidth;
    let screenY = window.innerHeight;

    const evt_resizeX = new Event('resize_x');
    const evt_resizeY = new Event('resize_y');

    window.addEventListener('resize', function (e) {
        let newScreenX = e.target.innerWidth;
        let newScreenY = e.target.innerHeight;

        if (newScreenX != screenX) {
            this.window.dispatchEvent(evt_resizeX);
            screenX = newScreenX;
        }

        if (newScreenY != screenY) {
            this.window.dispatchEvent(evt_resizeY);
            screenY = newScreenY;
        }
    });
})();


/**
 * Add a HTML class when window resizes (to block transitions when resizing to solve issues such as overlay panels flying out)
 */
(function() {
    'use strict';

    let htmlResizeTimeout;
    let classResizeX = 'html--resize_x';
    let classResizeY = 'html--resize_y';

    window.addEventListener('resize_x', function() {
        document.documentElement.classList.add(classResizeX);
        clearTimeout(htmlResizeTimeout);
        htmlResizeTimeout = setTimeout(function () {
            document.documentElement.classList.remove(classResizeX);
        }, 100);
    });

    /* window.addEventListener('resize_y', function() {
        console.log('height transition');
    }); */
}());


/**
 * Lazyload setup
 */
var lazyLoadInstance = (function() {
    'use strict';

    return new LazyLoad({
        restore_on_error: true,
        thresholds: "500px 0px",
    });
})();